/* eslint-disable @typescript-eslint/naming-convention */
export interface EmployeeJob {
  HRRef: string | number;
  bActive: boolean;
  CompanyID: string;
  CompanyName: string;
  VPCompanyID: number;
  EmployeeID: string;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  Suffix: string;
  VPID: string;
  FileClassID: number;
  FileClassName: string;
  EmDesignationID: number;
  EmDesignationName: string;
  Shift: number;
  PRGroup: string;
  PRDept: string;
  Craft: string;
  JobClassID: number;
  JobClass: string;
  ContractRate: number;
  PayRate: number;
  FilePayRate: number;
  FileOTFactor: number;
  OTFactor: number;
  FilePTFactor: number;
  PTFactor: number;
  FilePerDiem: number;
  PerDiem: number;
  BillPerDiem: number;
  StartDate: Date;
  EndDate: Date;
  ROFDate: Date;
  Mileage: number;
  MileageDesignation: string;
  PerDiemDocsStatusID: string;
  PerDiemDocsStatusName: string;
  I9Status: string;
  UserNotes: string;
  FieldPayRate: number;
  ShopPayRate: number;
  NonBillablePayRate: number;
  SSN: string;
  PerDiemPayCard: string;
  CheckPayCard: string;
  Phone: string;
  CellPhone: string;
  AlternatePhone: string;
  Email: string;
  JobID: string;
  EmployeeJobID: string;
  ManPowerReqDetailID: string;
  BirthDate: Date;
  Address: string;
  City: string;
  State: string;
  Zip: string;
  PhysicalStreetAddress: string;
  PhysicalCity: string;
  PhysicalState: string;
  PhysicalZip: string;
  PlantAddress: string;
  PlantCity: string;
  PlantState: string;
  PlantZip: string;
  HasSignedDispatchFiles: boolean;
  HasPerDiemDocFiles: boolean;
  ComDataRefNumber: string;
  MultiClassCopiedFromID: string; // US-195 - allow to dispatch again to multiple job classes and multiple shifts
  RequestedLinkedClassID: string;
  RequestedTradeClassID: string;
  RequestedClassName: string;
  // WI 30928: off-template Wage edit justification. Optional because they are only
  // populated in the off-template exception case (set on save by the dispatch detail
  // dialog); most EmployeeJob consumers never carry them. Set when a direct Wage edit
  // matches no known rate for the dispatch; carried onto the pay-rate exception report.
  PayRateExceptionReason?: string;
  PayRateExceptionNote?: string;
}
